import { render } from "./fqc.vue?vue&type=template&id=6320550e&scoped=true"
import script from "./fqc.vue?vue&type=script&lang=js"
export * from "./fqc.vue?vue&type=script&lang=js"

import "./fqc.vue?vue&type=style&index=0&id=6320550e&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6320550e"]])

export default __exports__